import React, { Component, Fragment } from 'react'
import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
import { Authenticator, AUTH_CALLBACK_URL } from '@kenetto/kenetto-redux-authenticator'

import {authActions} from '../../redux/auth'
import MainContainer from '../Main/MainContainer'
import LoginContainer from '../Login/LoginContainer'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import IdleTimer from 'react-idle-timer'
import TestPDF from './TestPDF'

const EnhancedAuthenticator = connect(null, mapDispatchToProps)(Authenticator)

class App extends Component {
  render () {
    const { location, auth, loginRequest, getProfile, handleAuthentication, profile } = this.props
    if (auth.isAuthenticated && !auth.profile) {
      getProfile()
    }
    return (
      <Switch>
        <Route
          exact
          path='/'
          render={props => {
            if (!auth.isAuthenticated) {
              return (
                <LoginContainer {...props} location={location} authenticate={() => loginRequest(location.state && location.state.referrer)} />
              )
            } else {
              return <Redirect to={'/patients'} />
            }
          }}
        />
        <Route
          exact
          path={AUTH_CALLBACK_URL}
          render={props => {
            return (
              <EnhancedAuthenticator
                handleAuthentication={handleAuthentication}
                location={props.location}>
                {profile
                  ? <Redirect push to={auth.returnUrl || '/patients'} />
                  : <div>Loading...</div>
                }
              </EnhancedAuthenticator>
            )
          }}
        />
        <Route path={'/test'} render={() => {
          return <div>
            <TestPDF />
          </div>
        }} />
        <Route
          path='/'
          render={props => {
            if (auth.isAuthenticated) {
              return <MainContainer {...props} auth={auth} />
            }
            return (
              <Redirect
                to={{
                  pathname: '/',
                  state: {referrer: props.location.pathname}
                }}
              />
            )
          }}
        />
        <Route render={() => <div>Not Found!!!</div>} />
      </Switch>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    profile: state.auth.profile
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(authActions, dispatch)
}

const withIdleDetector = (WrappedComponent) => {
  return class extends React.Component {
    constructor (props) {
      super(props)
      this.idleTimer = null
      this.onIdle = this.onIdle.bind(this)
    }

    onIdle (e) {
      // TODO Perform logout
      // console.log('user is idle', e)
      // console.log('last active', this.idleTimer.getLastActiveTime())
    }

    render () {
      return <Fragment>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={1000 * 5} />
        <WrappedComponent {...this.props} translate={this.translate} />
      </Fragment>
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withIdleDetector(App))
